/* src/app/components/shop/products/product/product.component.scss */
.thirdContainer {
  padding: 0 15px 10px;
  min-height: 104px;
}
.thirdContainer .addButton .mat-mdc-button {
  color: #231b1b;
  font-size: 13px !important;
  min-height: 36px;
  min-width: 260px;
  letter-spacing: 0 !important;
  text-align: center !important;
  padding: 0px 2px !important;
  border: 1px solid #3b4e60;
  background: #ffffff;
}
.color1-f-s-16 {
  font-size: 16px;
  color: #ffa500;
  font-family: roboto;
}
.color1-f-s-14 {
  font-size: 14px;
  color: #231b1b;
  font-family: roboto;
  font-weight: 700;
}
.borderBottom {
  border-bottom: 1px solid #d3d3d3;
}
button {
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 260px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 10px rgba(0, 0, 0, 0.12);
  font-weight: 500;
  font-size: 14px;
  font-style: inherit;
  font-variant: inherit;
  font-family: inherit;
  border-radius: 3px;
}
/*# sourceMappingURL=product.component.css.map */
